<ng-container *ngIf="(_damElements | paginate: paginationConfig) as damItems">
  <div class="plates-grid" *ngIf="isShowProductList">
    <ng-container *ngFor="let damItem of damItems">
      <div
        (click)="elementClickEvent(damItem);"
        class="item"
        [ngClass]="{
          'selected': damItem?.selected
        }"
      >
        <div class="actions-panel">
          <div class="actions-panel-top" (click)="$event.stopPropagation()">
            <a nbTooltip="Скачать" (click)="elementDownloadHandler(damItem)">
              <nb-icon icon="download-outline"/>
            </a>
            <a nbTooltip="Редактировать" target="_blank" href="/cabinet/dam/item/edit/{{damItem.id}}">
              <nb-icon icon="edit-outline"/>
            </a>
            <a nbTooltip="Переместить" (click)="elementChangeCatalogHandler(damItem)">
              <nb-icon icon="repeat-outline"/>
            </a>
            <a nbTooltip="Поделиться" (click)="elementShareHandler(damItem)">
              <nb-icon icon="share-outline"/>
            </a>
            <a nbTooltip="Удалить" (click)="elementDeleteHandler(damItem)">
              <nb-icon icon="trash-outline"/>
            </a>
          </div>
          <div class="actions-panel-bottom" *ngIf="damItem.tagsForPreview?.length>0">
            <span *ngFor="let tag of damItem.tagsForPreview?.slice(0,4)">{{ tag }}</span>
            <span *ngIf="damItem.tagsForPreview?.length > 4">+{{ damItem.tagsForPreview?.length - 4 }}</span>
          </div>
        </div>

        <app-secured-image
          [src]="'/dam/get-image-dynamic/' + damItem?.id + '/240'"
          style="height: 70%; width: 100%;"
        ></app-secured-image>

        <span class="item-title">
          {{ damItem.header }}
        </span>

        <div class="item-actions">
          <nb-checkbox
            (click)="$event.stopPropagation()"
            (checkedChange)="elementSelectHandler(damItem, $event);"
            [checked]="selected$.value.has(damItem.id)"/>

          <div class="item-actions-right">

            <nb-icon *ngIf="damItem.enabled" nbTooltip="Aктивен" icon="checkmark-circle-2-outline" status="success"/>
            <nb-icon *ngIf="!damItem.enabled" nbTooltip="Не активен" icon="checkmark-circle-2-outline" status="danger"/>
            <nb-icon *ngIf="damItem.approved" nbTooltip="Подтвержден" icon="shield-outline" status="success"/>
            <nb-icon *ngIf="!damItem.approved" nbTooltip="Не подтвержден" icon="shield-outline" status="danger"/>
            <nb-icon *ngIf="damItem.deleted" nbTooltip="Удален" icon="file-remove-outline" status="danger"/>

            <div class="item-actions-files">
              <nb-icon icon="attach-outline"/>
              <span class="item-actions-files__count">
                {{ damItem.countVersion }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>


  <div
    class="list"
    *ngIf="!isShowProductList"
  >
    <div
      class="list-header-column"
    >
      <nb-checkbox
        id="select-all"
        (click)="$event.stopPropagation()"
        (checkedChange)="toggleCheckboxes();"
        [checked]="isAllItemsSelected"/>

    </div>
    <div
      class="list-header-column"
    >
    </div>
    <div
      class="list-header-column"
    >
      Название
    </div>
    <div
      class="list-header-column"
    >
      Вложений
    </div>
    <div
      class="list-header-column"
    >
      Статус
    </div>
    <div
      class="list-header-column owner"
    >
      Владелец
    </div>
    <div
      class="list-header-column"
    >
      Теги
    </div>
    <div
      class="list-header-column empty"
    >
    </div>

    <ng-container
      *ngFor="let damItem of damItems; index as i"
    >
      <nb-checkbox
        class="select-item item-cell"
        [id]="'select-item-checkbox-' + i"
        (click)="$event.stopPropagation()"
        (checkedChange)="elementSelectHandler(damItem, $event);"
        [checked]="selected$.value.has(damItem.id)"/>

      <app-secured-image
        class="item-cell pd-0"
        (click)="elementClickEvent(damItem)"
        src="/dam/get-image-dynamic/{{damItem.id}}/240"
        style="height: 40px; width: 40px; padding: 0"
      ></app-secured-image>

      <span
        class="item-cell item-header"
      >
        <span
          class="item-header item-title"
        >
      {{ damItem.header }}
    </span>

    <span
      class="item-header created-at"
    >
      Создано {{ damItem.createdAt | date: 'dd.MM.yyyy HH:mm:ss' }}
    </span>
  </span>

      <div
        class="item-cell files"
      >
        <nb-icon icon="attach-outline"/>
        <span
          class="item-cell files__count "
        >
      {{ damItem.countVersion }}
    </span>
      </div>

      <div class="item-cell statuses">

        <nb-icon *ngIf="damItem.enabled" nbTooltip="Aктивен" icon="checkmark-circle-2-outline" status="success"/>
        <nb-icon *ngIf="!damItem.enabled" nbTooltip="Не активен" icon="checkmark-circle-2-outline" status="danger"/>
        <nb-icon *ngIf="damItem.approved" nbTooltip="Подтвержден" icon="shield-outline" status="success"/>
        <nb-icon *ngIf="!damItem.approved" nbTooltip="Не подтвержден" icon="shield-outline" status="danger"/>
        <nb-icon *ngIf="damItem.deleted" nbTooltip="Удален" icon="file-remove-outline" status="danger"/>
      </div>

      <div
        class="item-cell owner"
      >
    <span
      class="full-name"
    >
      {{ damItem.managerName }}
    </span>
      </div>

      <div
        class="item-cell tags"
      >
        <div class="tags__item" *ngFor="let tag of damItem.tagsForPreview?.slice(0,4)">{{ tag }}</div>
        <div class="tags__item" *ngIf="damItem.tagsForPreview?.length > 4">+{{ damItem.tagsForPreview?.length - 4 }}</div>
      </div>

      <div
        class="item-cell pd-0 actions"
      >
        <app-dropdown
          name="table-actions-preview"
          [index]="'table-actions-preview_' + i"
          direction="left"
          [showIcon]="false"
        >
          <ng-container ngProjectAs="placeholder">
            <nb-icon icon="more-vertical-outline"/>
          </ng-container>
          <ng-container ngProjectAs="dropdown">
            <div class="row-actions-popup dropdown-content-standard">
              <div class="row-actions-popup-row row">
                <nb-icon icon="download-outline"/>
                <span class="row-text">
              Скачать файл
            </span>
              </div>
              <hr class="divider-horizontal">
              <div class="row-actions-popup-row row">
                <nb-icon icon="copy-outline"/>
                <span class="row-text">
              Сопировать ссылку
            </span>
              </div>
              <div class="row-actions-popup-row row">
                <nb-icon icon="edit-outline"/>
                <span class="row-text">
              Редактировать
            </span>
              </div>
              <div
                (click)="deleteItem(damItem)"
                class="row-actions-popup-row row"
              >
                <nb-icon icon="trash-outline"/>
                <span class="row-text filter-alert">
              Удалить
            </span>
              </div>
            </div>
          </ng-container>
        </app-dropdown>
      </div>
    </ng-container>
  </div>
</ng-container>

<pagination
  [id]="paginationConfig.id"
  [config]="configuration"
  [pagination]="pagination"
  (update)="onPagination($event)"
/>
